// extracted by mini-css-extract-plugin
export default {"ReportTemplate":"ReportTemplate_ReportTemplate__IByF9"};